import React from "react";
import { ManageTradeLayout } from "../../../components";
import { Button, Image } from "react-bootstrap";
import { manageTradeFormNames, formFields } from "../../../utils";
import { SearchView } from "../SearchView";
import { CardsLayout } from "../CardsLayout";
import ExcelImage from "../../../styles/exportimg.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { isEmpty } from "lodash";
const columns = [
  {
    id: "cusip",
    label: "CUSIP",
    style: { paddingLeft: "0.5rem", fontSize: "14px", width: "17%" },
    className: "grey-text font-weight-700",
    styleName: "investment-cusip-col w-17",
  },
  {
    id: "transactionIdAndSource",
    label: "Transaction ID & Source",
    style: { fontSize: "14px", width: "17%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-17",
  },
  {
    id: "clearingPartnerId",
    label: "Clearing Partner ID",
    style: { fontSize: "14px", width: "17%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-17",
  },
  {
    id: "quantity",
    label: "Quantity",
    style: { fontSize: "14px", width: "12.25%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-1225",
  },
  {
    id: "amount",
    label: "Amount",
    style: { fontSize: "14px", width: "12.25%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-1225",
  },
  {
    id: "nav",
    label: "Nav",
    style: {
      fontSize: "14px",
      width: "12.25%",
    },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-1225 justify-content-center",
  },
  {
    id: "date",
    label: "Date",
    style: {
      fontSize: "14px",
      width: "12.25%",
    },
    className: "grey-text font-weight-700",
    styleName: "trade-flex-column w-1225 justify-content-center",
  },
];

const TradeOrderInvestmentContainer = (props) => {
  const TableContent = {
    cusip: (a, e) => {
      console.log(a, e, "args");
      return (
        <div className={a.styleName}>
          <div className="transaction-card-top-row">{"Apple"}</div>
          <div className="transaction-card-bottom-row">{"0374255422"}</div>
          <div className="transaction-card-bottom-row">
            Plan ID -<div className="plan-Id">123243</div>
          </div>
        </div>
      );
    },
    transactionIdAndSource: (a, e) => (
      <div className={a.styleName}>XXXX2345</div>
    ),
    clearingPartnerId: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    quantity: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    amount: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    nav: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    date: (a, e) => {
      console.log(a, e, "args");
      return (
        <div className={a.styleName}>
          <div className="transaction-card-top-row">{"6/6/2023 5:40"}</div>
          <div className="transaction-card-bottom-rom">
            <div className="transaction-status">
              <FontAwesomeIcon icon={faCheckCircle} />
              <div>{"completed"}</div>
            </div>
          </div>
        </div>
      );
    },
  };
  const onSubmit = () => {};
  return (
    <CardsLayout>
      <div className="column-filters">
        {columns.map((_) => (
          <div className={_.className} style={{ ..._.style }}>
            {" "}
            {_.label}
          </div>
        ))}
      </div>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((e, i) => {
        return (
          <div className="generic-table-component investment-trade-component">
            {columns.map((a, b) => {
              console.log(a, "regs");
              // const args = {...a,...e}
              return TableContent[a.id](a, e);
            })}
          </div>
        );
      })}
    </CardsLayout>
  );
};

export default TradeOrderInvestmentContainer;
